export default {
  SET_IN_MODERATION_COUNT: (state, value) => { state.inModerationCount = value; },
};
